export const sprite = {
    rotationDegrees: 15,
    w: 1192,
    h: 1650,
    icons: {
        "F100": {
            "rotates": true,
            "aliases": [
                "AJ27",
                "B712",
                "B717",
                "B721",
                "B722",
                "CRJ",
                "CRJ1",
                "CRJ2",
                "CRJ7",
                "CRJ9",
                "CRJX",
                "DC91",
                "DC93",
                "DC95",
                "E45X",
                "E135",
                "E145",
                "F70",
                "IL62",
                "MD80",
                "MD81",
                "MD82",
                "MD83",
                "MD87",
                "MD88",
                "MD90",
                "R721",
                "T154",
                "YK42",
                "T134",
                "YK40",
                "GL7T",
                "F28"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 385,
                        "w": 28,
                        "h": 28
                    },
                    "15": {
                        "x": 28,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    },
                    "30": {
                        "x": 54,
                        "y": 385,
                        "w": 24,
                        "h": 24
                    },
                    "45": {
                        "x": 78,
                        "y": 385,
                        "w": 27,
                        "h": 27
                    },
                    "60": {
                        "x": 105,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "75": {
                        "x": 134,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "90": {
                        "x": 163,
                        "y": 385,
                        "w": 28,
                        "h": 28
                    },
                    "105": {
                        "x": 191,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "120": {
                        "x": 220,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "135": {
                        "x": 249,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    },
                    "150": {
                        "x": 275,
                        "y": 385,
                        "w": 24,
                        "h": 24
                    },
                    "165": {
                        "x": 299,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    },
                    "180": {
                        "x": 325,
                        "y": 385,
                        "w": 28,
                        "h": 28
                    },
                    "195": {
                        "x": 353,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    },
                    "210": {
                        "x": 379,
                        "y": 385,
                        "w": 24,
                        "h": 24
                    },
                    "225": {
                        "x": 403,
                        "y": 385,
                        "w": 27,
                        "h": 27
                    },
                    "240": {
                        "x": 430,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "255": {
                        "x": 459,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "270": {
                        "x": 488,
                        "y": 385,
                        "w": 28,
                        "h": 28
                    },
                    "285": {
                        "x": 516,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "300": {
                        "x": 545,
                        "y": 385,
                        "w": 29,
                        "h": 29
                    },
                    "315": {
                        "x": 574,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    },
                    "330": {
                        "x": 600,
                        "y": 385,
                        "w": 24,
                        "h": 24
                    },
                    "345": {
                        "x": 624,
                        "y": 385,
                        "w": 26,
                        "h": 26
                    }
                }
            ]
        },
        "RJ85": {
            "rotates": true,
            "aliases": [
                "143",
                "B461",
                "B462",
                "B463",
                "C17",
                "IL76",
                "RJ1H",
                "RJ70",
                "RJ100",
                "J328"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 440,
                        "w": 26,
                        "h": 26
                    },
                    "15": {
                        "x": 26,
                        "y": 440,
                        "w": 27,
                        "h": 27
                    },
                    "30": {
                        "x": 53,
                        "y": 440,
                        "w": 27,
                        "h": 27
                    },
                    "45": {
                        "x": 80,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "60": {
                        "x": 108,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "75": {
                        "x": 137,
                        "y": 440,
                        "w": 30,
                        "h": 30
                    },
                    "90": {
                        "x": 167,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "105": {
                        "x": 195,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "120": {
                        "x": 224,
                        "y": 440,
                        "w": 30,
                        "h": 30
                    },
                    "135": {
                        "x": 254,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "150": {
                        "x": 283,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "165": {
                        "x": 311,
                        "y": 440,
                        "w": 26,
                        "h": 26
                    },
                    "180": {
                        "x": 337,
                        "y": 440,
                        "w": 26,
                        "h": 26
                    },
                    "195": {
                        "x": 363,
                        "y": 440,
                        "w": 27,
                        "h": 27
                    },
                    "210": {
                        "x": 390,
                        "y": 440,
                        "w": 27,
                        "h": 27
                    },
                    "225": {
                        "x": 417,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "240": {
                        "x": 445,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "255": {
                        "x": 474,
                        "y": 440,
                        "w": 30,
                        "h": 30
                    },
                    "270": {
                        "x": 504,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "285": {
                        "x": 532,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "300": {
                        "x": 561,
                        "y": 440,
                        "w": 30,
                        "h": 30
                    },
                    "315": {
                        "x": 591,
                        "y": 440,
                        "w": 29,
                        "h": 29
                    },
                    "330": {
                        "x": 620,
                        "y": 440,
                        "w": 28,
                        "h": 28
                    },
                    "345": {
                        "x": 648,
                        "y": 440,
                        "w": 26,
                        "h": 26
                    }
                }
            ]
        },
        "A320": {
            "rotates": true,
            "aliases": [
                "A32",
                "A321",
                "A20N",
                "A21N"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 495,
                        "w": 30,
                        "h": 30
                    },
                    "15": {
                        "x": 30,
                        "y": 495,
                        "w": 30,
                        "h": 30
                    },
                    "30": {
                        "x": 60,
                        "y": 495,
                        "w": 28,
                        "h": 28
                    },
                    "45": {
                        "x": 88,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "60": {
                        "x": 117,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    },
                    "75": {
                        "x": 148,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "90": {
                        "x": 180,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "105": {
                        "x": 212,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "120": {
                        "x": 244,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    },
                    "135": {
                        "x": 275,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "150": {
                        "x": 304,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "165": {
                        "x": 333,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    },
                    "180": {
                        "x": 364,
                        "y": 495,
                        "w": 30,
                        "h": 30
                    },
                    "195": {
                        "x": 394,
                        "y": 495,
                        "w": 30,
                        "h": 30
                    },
                    "210": {
                        "x": 424,
                        "y": 495,
                        "w": 28,
                        "h": 28
                    },
                    "225": {
                        "x": 452,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "240": {
                        "x": 481,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    },
                    "255": {
                        "x": 512,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "270": {
                        "x": 544,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "285": {
                        "x": 576,
                        "y": 495,
                        "w": 32,
                        "h": 32
                    },
                    "300": {
                        "x": 608,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    },
                    "315": {
                        "x": 639,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "330": {
                        "x": 668,
                        "y": 495,
                        "w": 29,
                        "h": 29
                    },
                    "345": {
                        "x": 697,
                        "y": 495,
                        "w": 31,
                        "h": 31
                    }
                }
            ]
        },
        "A330": {
            "rotates": true,
            "aliases": [
                "A31",
                "AB6",
                "B762",
                "B763",
                "B764",
                "A300",
                "A30B",
                "A306",
                "A310",
                "A332",
                "A333",
                "A338",
                "A339",
                "A359",
                "B787",
                "B788",
                "B789",
                "B78X"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "15": {
                        "x": 35,
                        "y": 770,
                        "w": 34,
                        "h": 34
                    },
                    "30": {
                        "x": 69,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "45": {
                        "x": 101,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "60": {
                        "x": 133,
                        "y": 770,
                        "w": 34,
                        "h": 34
                    },
                    "75": {
                        "x": 167,
                        "y": 770,
                        "w": 36,
                        "h": 36
                    },
                    "90": {
                        "x": 203,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "105": {
                        "x": 238,
                        "y": 770,
                        "w": 36,
                        "h": 36
                    },
                    "120": {
                        "x": 274,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "135": {
                        "x": 309,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "150": {
                        "x": 341,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "165": {
                        "x": 373,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "180": {
                        "x": 408,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "195": {
                        "x": 443,
                        "y": 770,
                        "w": 34,
                        "h": 34
                    },
                    "210": {
                        "x": 477,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "225": {
                        "x": 509,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "240": {
                        "x": 541,
                        "y": 770,
                        "w": 34,
                        "h": 34
                    },
                    "255": {
                        "x": 575,
                        "y": 770,
                        "w": 36,
                        "h": 36
                    },
                    "270": {
                        "x": 611,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "285": {
                        "x": 646,
                        "y": 770,
                        "w": 36,
                        "h": 36
                    },
                    "300": {
                        "x": 682,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    },
                    "315": {
                        "x": 717,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "330": {
                        "x": 749,
                        "y": 770,
                        "w": 32,
                        "h": 32
                    },
                    "345": {
                        "x": 781,
                        "y": 770,
                        "w": 35,
                        "h": 35
                    }
                }
            ]
        },
        "A340": {
            "rotates": true,
            "aliases": [
                "343",
                "346",
                "A342",
                "A343",
                "B703",
                "DC86",
                "DC87",
                "E6",
                "IL86",
                "IL96",
                "C135",
                "E3CF",
                "R135",
                "K35R",
                "E3TF",
                "K35E",
                "A345",
                "A346"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "15": {
                        "x": 39,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "30": {
                        "x": 78,
                        "y": 825,
                        "w": 36,
                        "h": 36
                    },
                    "45": {
                        "x": 114,
                        "y": 825,
                        "w": 35,
                        "h": 35
                    },
                    "60": {
                        "x": 149,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "75": {
                        "x": 188,
                        "y": 825,
                        "w": 40,
                        "h": 40
                    },
                    "90": {
                        "x": 228,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "105": {
                        "x": 267,
                        "y": 825,
                        "w": 40,
                        "h": 40
                    },
                    "120": {
                        "x": 307,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "135": {
                        "x": 346,
                        "y": 825,
                        "w": 35,
                        "h": 35
                    },
                    "150": {
                        "x": 381,
                        "y": 825,
                        "w": 36,
                        "h": 36
                    },
                    "165": {
                        "x": 417,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "180": {
                        "x": 456,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "195": {
                        "x": 495,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "210": {
                        "x": 534,
                        "y": 825,
                        "w": 36,
                        "h": 36
                    },
                    "225": {
                        "x": 570,
                        "y": 825,
                        "w": 35,
                        "h": 35
                    },
                    "240": {
                        "x": 605,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "255": {
                        "x": 644,
                        "y": 825,
                        "w": 40,
                        "h": 40
                    },
                    "270": {
                        "x": 684,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "285": {
                        "x": 723,
                        "y": 825,
                        "w": 40,
                        "h": 40
                    },
                    "300": {
                        "x": 763,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    },
                    "315": {
                        "x": 802,
                        "y": 825,
                        "w": 35,
                        "h": 35
                    },
                    "330": {
                        "x": 837,
                        "y": 825,
                        "w": 36,
                        "h": 36
                    },
                    "345": {
                        "x": 873,
                        "y": 825,
                        "w": 39,
                        "h": 39
                    }
                }
            ]
        },
        "B747": {
            "rotates": true,
            "aliases": [
                "743",
                "744",
                "A124",
                "B741",
                "B742",
                "B743",
                "B744",
                "B74S",
                "B748",
                "BLCF",
                "C5"
            ],
            "frames": [
                {
                    "0": {
                        "x": 0,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "15": {
                        "x": 39,
                        "y": 935,
                        "w": 37,
                        "h": 37
                    },
                    "30": {
                        "x": 76,
                        "y": 935,
                        "w": 33,
                        "h": 33
                    },
                    "45": {
                        "x": 109,
                        "y": 935,
                        "w": 35,
                        "h": 35
                    },
                    "60": {
                        "x": 144,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    },
                    "75": {
                        "x": 182,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "90": {
                        "x": 221,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "105": {
                        "x": 260,
                        "y": 935,
                        "w": 40,
                        "h": 40
                    },
                    "120": {
                        "x": 300,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    },
                    "135": {
                        "x": 338,
                        "y": 935,
                        "w": 35,
                        "h": 35
                    },
                    "150": {
                        "x": 373,
                        "y": 935,
                        "w": 34,
                        "h": 34
                    },
                    "165": {
                        "x": 407,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    },
                    "180": {
                        "x": 445,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "195": {
                        "x": 484,
                        "y": 935,
                        "w": 37,
                        "h": 37
                    },
                    "210": {
                        "x": 521,
                        "y": 935,
                        "w": 33,
                        "h": 33
                    },
                    "225": {
                        "x": 554,
                        "y": 935,
                        "w": 35,
                        "h": 35
                    },
                    "240": {
                        "x": 589,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    },
                    "255": {
                        "x": 627,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "270": {
                        "x": 666,
                        "y": 935,
                        "w": 39,
                        "h": 39
                    },
                    "285": {
                        "x": 705,
                        "y": 935,
                        "w": 40,
                        "h": 40
                    },
                    "300": {
                        "x": 745,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    },
                    "315": {
                        "x": 783,
                        "y": 935,
                        "w": 35,
                        "h": 35
                    },
                    "330": {
                        "x": 818,
                        "y": 935,
                        "w": 34,
                        "h": 34
                    },
                    "345": {
                        "x": 852,
                        "y": 935,
                        "w": 38,
                        "h": 38
                    }
                }
            ]
        }
    }
}